/**
 * `process.env.tmrEnv.tmrApiPrefix` takes precedence. It can be passed:
 * - By setting tmrApiPrefix in tmr-env.json
 * - By passing the env variable BACKEND_URL (see README.md)
 */
export const constant = [
  'tmrApiPrefix',
  process.env.tmrEnv.tmrApiPrefix ?? 'chiesi-tmr-api',
]
